import { adminRoutes } from 'app/constants/routes';
import { RouteBuilderItem } from 'app/routes/routeBuilder';

import { Setup } from './SetupRouteComponents';

export const setupRoutes: RouteBuilderItem[] = [
  /* eslint-disable @typescript-eslint/naming-convention */
  {
    Component: Setup,
    path: adminRoutes.setup,
  },
  /* eslint-enable @typescript-eslint/naming-convention */
];
